<template>
  <v-card>
    <v-card-title class="secondary white--text rounded-lg mb-4">
      <span
          style="cursor: pointer"
          @click="filters['is_service'] = false"
          :class="(filters['is_service'] == false)?'primary--text font-weight-bold':null">
        گزارش سود کالا
      </span>
      <span class="mr-5 ml-5">
        |
      </span>
      <span
          style="cursor: pointer"
          @click="filters['is_service'] = true"
          :class="(filters['is_service'] == true)?'primary--text font-weight-bold':null">
        گزارش سود خدمات
      </span>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="2">
          <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg"
              :items="wareLevels"
              v-model="filters.level"
              label="سطح کالا"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field class="rounded-lg" label="از کد کالا" type="number" v-model="filters.ware__code__gte"
                        clearable :disabled="filters.is_service == null"/>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field class="rounded-lg " label="تا کد کالا" type="number" v-model="filters.ware__code__lte"
                        clearable :disabled="filters.is_service == null"/>
        </v-col>
        <v-col cols="12" md="2">
          <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg"
              :items="waresStatuses"
              v-model="filters.status"
              label="وضعیت کالا"
          ></v-select>
        </v-col>
        <v-col cols="12" md="2">
          <ware-select class="rounded-lg" label="انتخاب کالا" type="text" v-model="filters.id"
                       clearable :show-info="false"/>
        </v-col>

        <v-col cols="12">
          <m-datatable :headers="headers" :api-url="url" :filters.sync="filters" :show-select="false" ref="datatable"/>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import wareApiMixin from "@/mixin/wareApi";

export default {
  props: {
    wareId: {},
    type: {
      required: true,
    },
  },
  mixins: [wareApiMixin],
  data() {
    return {
      ware: null,
      sums: null,
      filters: {
        id: "",
        status: null,
        name__icontains: "",
        level: null,
        is_service: null,
      },
      headers: [
        {
          text: "کد",
          value: "code",
          sortable: false,
        },
        {
          text: "نام کالا",
          value: "name",
          sortable: false,
        },
        {
          text: "فروش خالص",
          value: "1",
          type: "numeric",
        },
        {
          text: "بهای تمام شده کالای فروش رفته",
          value: "1",
          type: "numeric",
        },
        {
          text: "سود ناخالص",
          value: "1",
          type: "numeric",
        },
        {
          text: "درصد ناخالص حاشیه سود",
          value: "1",
          type: "numeric",
        },

      ],
    };
  },
  created() {
    this.getData();
    this.getSums();
  },
  methods: {
    getData() {
      Promise.all([this.getWares()]).then((data) => {
        this.init();
      });
    },
    getSums() {
      this.request({
        url: this.endpoint(`reports/buySaleSum?type=` + this.type),
        method: "get",
        success: (data) => {
          this.sums = data
        },
      });
    },

    init() {
      this.log("init list");
      this.setDefaultFilters();

      if (this.wareId) {
        this.ware = this.wares.filter((o) => o.id == this.wareId)[0];
      }
    },
    setDefaultFilters() {
      this.filters["status"] = "all";
      this.filters["is_service"] = false;
    },
    selectWare() {
      this.filters.ware = this.ware.id;
    },
  },
  computed: {
    backFromType(){
      if (this.type == 'buy'){
        return 'backFromBuy'
      } else {
        return 'backFromSale'
      }
    }
  },
  watch: {
    form() {
      this.init();
    },
    type() {
      this.init();
    },
    ware: {
      handler() {
        this.selectWare();
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss"></style>
